<script>
    /**
 *
 *
 *
 *
 *
 */

    import { generateRandomId } from "../utils/IdentifierGenerator.js";
    import { getContext } from "svelte";
    import { key as contentDresonRuleCtxKey } from "../context/contentDresonRule.js";

    /*                */
    let { deal = null, variationId = null, featuresState = {}, personalisedUser = false } = $props();

    const unavailableMessage = "-";
    const sheetId = generateRandomId(16);
    const dresonRule = getContext(contentDresonRuleCtxKey);
    const contextDresonParam = dresonRule ? `&contextDreson=${dresonRule}` : "";
</script>

{#if featuresState.ENABLE_SHEET_SERVICE_FOR_DEALBADGES}
    {#if deal && deal.imageUrl}
        <button
            onclick={(event) => event.preventDefault()}
            data-oc-sheet-v1-create
            data-oc-sheet-v1-create.id="reco_deal_sheet_{sheetId}"
            data-oc-sheet-v1-create.base64Url={btoa(
                `/benefit-sheet/sheet/recoProductCampaignFlag/${deal.id}?variationId=${variationId}${contextDresonParam}&personalized=${personalisedUser}`
            )}
            data-oc-sheet-v1-create.url={`/benefit-sheet/sheet/recoProductCampaignFlag/${deal.id}?variationId=${variationId}${contextDresonParam}&personalized=${personalisedUser}`}
            aria-label="Deal badge"
            class="reco_cinema__image__badge reco_cinema__image__deal_badge"
            style={`background: url(${deal.imageUrl}) center center/50px 50px no-repeat;`}
        >
        </button>
    {/if}
{:else}
    <div
        role="paragraph"
        class="reco_cinema__image__badge reco_cinema__image__deal_badge js_openInPaliSheet"
        data-qa="dealIcon"
        data-sheet-title="Warum sehe ich diese Fläche?"
        data-sheet-content="
     <div class='pl_copy100'>
        <div class='pl_mb150'>
            <p>Hier handelt es sich um eine gesponserte Fläche. Das sind Werbeanzeigen, die von unseren Lieferanten und Händlern finanziert werden.</p>
            <p>Wir achten darauf, dass diese Anzeigen zu deinem Interesse bzw. deiner Suche passen.</p>
        </div>
        <div class='pl_mb150'>
            <div class='pl_headline100 pl_mb50'>Persönliche Empfehlungen</div>
            <p>Die Ausspielung der Artikel basiert auf deiner Shoppinghistorie.</p>
        </div>
        <div class='pl_headline100 pl_mb50'>Über den Werbetreibenden</div>
        <ul class='pl_list--unordered'>
            <li><b>Name des Werbetreibenden:</b> {`${deal.advertiser || unavailableMessage}`}</li>
            <li><b>Wer hat für diese Anzeige bezahlt:</b> {`${deal.funder || unavailableMessage}`}</li>
        </ul>
     </div>"
        style={`background: url(${deal.imageUrl}) center center/50px 50px no-repeat;`}
    >
        &nbsp;
    </div>
{/if}

<style>
    .reco_cinema__image__badge {
        background-size: cover;
    }

    .reco_cinema__image__deal_badge {
        position: absolute;
        width: 50px;
        height: 50px;
        z-index: 1;
        top: 12px;
        left: 12px;
        border: none;
        cursor: pointer;
    }
</style>
